<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <producto-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ProductoShowData from "./ProductoShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ProductoShow",
        components: {CrudShow, ProductoShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'producto.showing',
            }
        },
    }
</script>

